module.exports = __webpack_public_path__ + "static/apple_store_badge-f41d861a8969665ddd8eb87136b4c772.svg";